import type { FC } from 'react';
import { FormSection } from '@patternfly/react-core/dist/dynamic/components/Form';
import { TextInputTypes } from '@patternfly/react-core/dist/dynamic/components/TextInput';
import { useTranslation } from 'react-i18next';
import { InputField } from '@console/shared';

const AdminNamespaceSection: FC = () => {
  const { t } = useTranslation();

  return (
    <FormSection data-test="admin-namespace-section">
      <InputField
        type={TextInputTypes.text}
        name="namespace"
        label={t('webterminal-plugin~Project')}
        helpText={t(
          'webterminal-plugin~This Project will be used to initialize your command line terminal',
        )}
        isDisabled
        required
      />
    </FormSection>
  );
};

export default AdminNamespaceSection;
